export default __webpack_public_path__ + "static/media/TechoKidsFinalLogo2.8cd592d0.png";